import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';
import { messagesStore } from '../../store/messages';
import { IMessageModal } from '../../types/messages';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Portal from 'src/view/components/Portal/Portal';
import './style.scss';

interface IProps {
  data: IMessageModal;
}

const Message: FC<IProps> = ({ data }: IProps): JSX.Element => {
  const { id, content } = data;
  const isOnlyMessage = useMemo((): boolean => !content.Content && !content.options?.length, [content]);

  const requestClose = useCallback(() => {
    if (content.onRequestClose) content.onRequestClose();
    messagesStore.removeMessage(id);
  }, [id, content]);

  const onButtonPress = (cb: (() => void) | undefined) => () => {
    if (cb) cb();
    requestClose();
  };

  return (
    <Portal>
      <div className={classNames('message', content.className)}>
        <div className="message__backdrop" onClick={requestClose}></div>
        <div className={classNames('message__content', content.contentClassName, { 'pb-4': isOnlyMessage })}>
          {/* title */}
          {content.title && !content.hideTitle ? (
            <p className="family-semibold color-dark text-size-20 text-center font-weight-500 px-8 mb-3">{content.title}</p>
          ) : null}

          {/* message */}
          {content.message && !content.hideMessage ? (
            <p className="family-regular color-dark text-size-16 text-center font-weight-400 px-8">{content.message}</p>
          ) : null}

          {/* props content */}
          {content.Content ? <content.Content data={data} /> : null}

          {/* options  */}
          {content.options?.length ? (
            <div className="d-flex flex-1 mt-4 gap-10">
              {content.options?.map((option, index) => (
                <Button
                  key={index}
                  title={option.title}
                  onClick={onButtonPress(option.onPress)}
                  stretched={option.stretched}
                  appearance={option.appearance}
                  className={option.className}
                  titleClassName={option.titleClassName}
                />
              ))}
            </div>
          ) : null}

          {/* close button */}
          {content.hideCloseIcon ? null : (
            <Icon name={Icons.Close} size={14} color={theme.colors.gray2} onPress={requestClose} className="message__close" />
          )}
        </div>
      </div>
    </Portal>
  );
};

export default Message;
